module.exports = __webpack_public_path__ + "static/media/product-detail-small.2c4d0778.webp";